import { createModel } from "hox";
import useStorageState from "../hooks/useStorageState";

export type RoleType = {
    id: number,
    name: String,
};
export type UserType = {
    username: string,
    password: string,
    token: string,
    [key: string]: any
}

type GlobalModelType = {
    user: UserType,
    setUser: (e: UserType) => void,
    resetUser: () => void,
    toggleMenu: () => void,
    cm: CmType,
    resetCm: () => void,
    userMenu: UserMenuAuthType,
    setUserMenu: (e: UserMenuAuthType) => void,
};


const initUserState = {
    username: "",
    password: "",
    token: ""
}

type CmType = {
    collapsed: boolean
}
type UserMenuAuthType = {
    [key: string]: any
}
const initCmState = {
    collapsed: false
}

function useModel(): GlobalModelType {
    const [user, setUser, resetUser] = useStorageState<UserType>('user', initUserState);
    const [userMenu, setUserMenu, resetUserMenu] = useStorageState<UserMenuAuthType>('usermenu', []);

    const [cm, setCm, resetCm] = useStorageState<CmType>('cm', initCmState);


    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed
        })
    }

    return {
        user,
        setUser,
        userMenu,
        setUserMenu,
        resetUser,
        toggleMenu,
        cm,
        resetCm,
    };
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel;
